import { Divider, Drawer, MenuList, MenuItem, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { RoutePath } from '../util/Routes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      zIndex: 0,
      marginTop: '64px',
      height: 'calc(100% - 64px)',
    },
    mainGrid: {
      width: 310,
    },
    navList: {
      width: '100%',
      padding: 0,
    },
    sectionHeader: {
      letterSpacing: 1.5,
      fontSize: 12,
      padding: theme.spacing(2, 2, 0.5, 2),
      color: theme.palette.text.secondary,
    },
    menuItem: {
      height: 55,
      textDecoration: 'none',
      color: theme.palette.text.primary,
      '&>.MuiDivider-root': {
        width: 'calc(100% - 12px)',
        position: 'absolute',
        top: 0,
        left: 0,
        marginLeft: 12,
      },
    },
    menuItemIcon: {
      marginRight: theme.spacing(2),
      color: theme.palette.uxGrey.main,
    },
  }),
);

const ApteanAdminMenu: React.FC = () => {
  const classes = useStyles();

  return (
    <Drawer open variant="persistent" anchor="left" classes={{ paper: classes.drawerPaper }} data-cy="aptean-admin-menu">
      <div className={classes.mainGrid}>
        <Typography className={classes.sectionHeader}>MERCHANTS</Typography>
        <MenuList className={classes.navList}>
          <MenuItem component={NavLink} className={classes.menuItem} to="/" exact data-cy="nav-all-merchants">
            <Divider />
            <ListAltIcon className={classes.menuItemIcon} />
            All merchants
          </MenuItem>
        </MenuList>
        <Typography className={classes.sectionHeader}>ADMINISTRATION</Typography>
        <MenuList className={classes.navList}>
          <MenuItem component={NavLink} className={classes.menuItem} to={RoutePath.ApteanAdminUsers} data-cy="nav-manage-aptean-users">
            <Divider />
            <ManageAccountsIcon className={classes.menuItemIcon} />
            Manage Aptean Users
          </MenuItem>
        </MenuList>
      </div>
    </Drawer>
  );
};

export default ApteanAdminMenu;
